import { Component, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { NavController, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { CommonVariable } from "src/app/app.constants";
import { RequestConfirmationComponent } from "src/app/components/add-home-screen/request-confirmation/request-confirmation.component";
import { SafeHtmlPipe } from "../../../pipe/safehtmlpipe";

@Component({
    templateUrl: "./request-data.component.html",
    styleUrls: ["./request-data.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        SafeHtmlPipe,
        TranslatePipe,
    ],
})
export class ReqDataComponent implements OnDestroy {
  syndicateLoaded: boolean;
  jackpotLoaded: boolean;

  setActive = true;
  setActiveTrigger = true;
  translatedToastMsg: Data;
  selectedLanguage = "en";
  public preferredCurrency: string;
  public currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  public spinnerAnimation: boolean;
  public progressBar: number;
  public sub: Data;
  public proceed = true;
  private unsubscribe$ = new Subject<void>();

  constructor(
    public translate: TranslateService,
    private authService: AuthService,
    private navController: NavController,
    private router: Router,
    private matDialog: MatDialog
  ) {
    this.preferredCurrency = CommonVariable.preferredCurrency;
    this.currencySymbol = CommonVariable.defaultCurrencySymbol;
    this.authService.selectedlanguage$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }
  ngOnDestroy(): void {
    this.unsubscribe$?.next();
    this.unsubscribe$?.complete();
  }

  goBack() {
    this.navController.back();
  }

  goToGetHelpPage() {
    this.router.navigateByUrl("account/helpSupport?bot_flow=hi");
  }

  goToDeleteAccountPage() {
    this.router.navigateByUrl("delete-your-account");
  }

  onRequestData() {
    this.matDialog.open(RequestConfirmationComponent, {
      panelClass: "request-confirmation-popup",
      backdropClass: "back-drop-popup",
      enterAnimationDuration: "500ms",
      exitAnimationDuration: "500ms",
    });
  }

}
